/*************************************************************
 *************************************************************
 *************************************************************
 *             DO NOT MODIFY THIS FILE DIRECTLY!             *
 *      This is generated on build from the contents of      *
 *  `src/lang/en.properties`. Any new keys should be added   *
 *                          there.                           *
 *************************************************************
 *************************************************************
 *************************************************************/
import { default as c42Text } from '@c42/i18n/dist/Text';

export type TextKey =
  | '_button_continue' /* Continue */
  | '_placeholder_username_or_email' /* Username or email address */
  | '_placeholder_password' /* Password */
  | '_placeholder_enter_code' /* Authentication code */
  | '_validate_username_or_email' /* Username or email address required */
  | '_validate_password_header' /* A valid password must */
  | '_validate_password_required' /* Password is required */
  | '_validate_password_minlength' /* Be at least ${MinLength} characters long */
  | '_validate_password_number' /* Contain at least 1 number (0-9) */
  | '_validate_password_lower' /* Contain at least 1 lowercase letter */
  | '_validate_password_upper' /* Contain at least 1 uppercase letter */
  | '_validate_password_whitespace' /* Not contain any spaces */
  | '_validate_password_repeating' /* Not contain characters repeated 3 times or more */
  | '_validate_password_dictionary' /* Not be commonly used */
  | '_validate_password_requirements' /* Password does not meet the requirements */
  | '_validate_password_confirm_required' /* Password confirmation is required */
  | '_validate_totp_required' /* Authentication code is required */
  | '_flash_password_reset_check_email' /* Check your email for password reset instructions. */
  | 'sso_signin_different_account' /* Sign in with a different account */
  | 'sso_title' /* Single Sign-On */
  | 'sso_load_idps_error' /* Problem loading providers */
  | 'login_button_sign_in' /* Sign In */
  | 'login_error_passwordConfirm' /* Passwords do not match */
  | 'login_error_incorrect' /* Unable to sign in. Please check username and password. */
  | 'login_error_incorrect_totp' /* Unable to sign in. Please check username, password, and authentication code. */
  | 'login_error_auth' /* Unable to sign in, user is unauthorized. */
  | 'login_error_rate_limited' /* Too many login attempts. Please try again later. */
  | 'login_config_error_generic' /* An error occurred */
  | 'redirect_to_SMB_login_text' /* Sign in to CrashPlan for Small Business */
  | 'redirect_to_Incydr_login_text' /* Sign in to Incydr */
  | 'redirect_to_CrashPlan_login_text' /* Sign in to CrashPlan */
  | 'login_totp_config_headline' /* Set up two-factor authentication */
  | 'login_totp_config_description' /* Your Incydr administrator requires two-factor authentication to sign in with this account. */
  | 'login_totp_config_step1_headline' /* Install an authenticator */
  | 'login_totp_config_step1_details' /* Recommended: */
  | 'login_totp_config_step1_app' /* Mobile app authentication */
  | 'login_totp_config_step1_browser' /* Browser based authentication */
  | 'login_totp_config_device_ios' /* iOS */
  | 'login_totp_config_device_android' /* Android */
  | 'login_totp_config_browser_firefox' /* Firefox */
  | 'login_totp_config_browser_chrome' /* Chrome */
  | 'login_totp_config_browser_edge' /* Edge */
  | 'login_totp_config_step2_headline' /* Add account */
  | 'login_totp_config_step2_opt1_or' /* Scan QR Code below, or */
  | 'login_totp_config_step2_opt1_or_enter' /* Scan QR Code below in your authenticator or manually enter the following <strong>in your authenticator</strong>: */
  | 'login_totp_config_step2_opt2' /* View code for manual entry or API setup */
  | 'login_totp_config_step3_headline' /* Enter 6-digit verification code */
  | 'login_totp_config_step3_description' /* Provided by your authenticator (numbers only) */
  | 'login_totp_config_step3_error' /* Invalid code */
  | 'login_totp_code_tooltip' /* To get your code, go to your two-factor authentication app (for example, Google Authenticator). */
  | 'login_totp_storage_node_warning_description' /* You must set up two-factor authentication to log in with this account. This can only be done on the <strong>authority server</strong>. Once you've set up two-factor authentication you may attempt to log back in to the storage node. */
  | 'login_totp_storage_node_warning_more_info' /* For more information, <a href="${url}" target="_blank">contact our Customer Champions.</a> */
  | 'login_forgot_password' /* Forgot Password */
  | 'login_reset_password' /* Reset password */
  | 'login_new_password' /* New password */
  | 'login_confirm_new_password' /* Confirm new password */
  | 'login_password_reset_success' /* Password reset successfully. */
  | 'login_password_reset_error' /* Couldn't reset your password. */
  | 'login_password_reset_invalid_token' /* Unable to reset your password. Click "Forgot Password" below to send a new reset link to your email. */
  | 'login_back_to_sign_in' /* Back to sign in */
  | 'login_support_need_help' /* Need help? */
  | 'login_support_learn_more' /* Learn more about signing in. */
  | 'support_login_access_type_label' /* Access type */
  | 'support_login_copy_bearer_token' /* Copy Bearer Token */
  | 'support_login_copy_bearer_token_error' /* Failed to copy bearer token. Please try again. */
  | 'support_login_copy_sts_session_token' /* Copy STS Session Token */
  | 'support_login_email' /* Email */
  | 'support_login_employee_info_error' /* An unexpected error occured, please try again later. (Loading employee info) */
  | 'support_login_jwt_error' /* Sign in failed. Ensure the tenant ID is valid or try again later. */
  | 'support_login_support_access_disabled' /* Support access is disabled for this tenant. */
  | 'support_login_tenant_id_label' /* Tenant ID or X1 Account Code */
  | 'support_login_tenant_info_error' /* An unexpected error occured, please try again later. (Loading tenant info) */
  | 'support_login_tenant_name_label' /* Tenant name */
  | 'copy_to_clipboard_success' /* Copied to clipboard */
  | 'incydr_header' /* Incydr */
  | 'login_unauthorized_incydr_header' /* Missing Incydr permissions */
  | 'login_unauthorized_incydr_desc_1' /* Your Incydr user account does not have permission to view the Incydr console. */
  | 'login_unauthorized_incydr_desc_2' /* Contact your Incydr administrator to request a user role with the required permissions. */
  | 'ssoAuthSignIn_success_message1' /* Sign in successful */
  | 'ssoAuthSignIn_success_message2' /* The backup agent will be signed in automatically. You can close this window. */
  | 'ssoAuthSignIn_incorrect_page_title' /* Login Error */
  | 'ssoAuthSignIn_incorrect_message1' /* Authentication failed */
  | 'ssoAuthSignIn_incorrect_message2' /* Please contact your administrator. */
  | 'ssoAuthSignIn_incorrect_message2_alt' /* Please try again or contact your administrator. */
  | 'ssoAuthSignIn_incorrect_message2_browser' /* Go to the backup agent to retry, or contact your administrator. You can close this window. */
  | 'sso_doc_title_error' /* Login Error */
  | 'sso_doc_title_success' /* Incydr Administration Console */
  | 'ssoAuthSignIn_try_again' /* Try again */
  | 'support_sso_error_title' /* Login error */
  | 'unexpected_error' /* An unexpected error occurred */
  | 'support_login_view_audit_log' /* View Login Audit Log */
  | 'audit_log_title' /* Login Audit Log */
  | 'audit_log_back_to_login' /* Back to Login */
  | 'audit_log_employee_id_label' /* Employee ID */
  | 'audit_log_employee_id_placeholder' /* Enter employee ID (e.g., support-user-<id>) */
  | 'audit_log_employee_id_helper' /* Example: support-user-<id> */
  | 'audit_log_search_button' /* Search */
  | 'audit_log_col_tenant_id' /* Tenant ID */
  | 'audit_log_col_tenant_name' /* Tenant name */
  | 'audit_log_col_account_code' /* Account code */
  | 'audit_log_col_login_type' /* Login type */
  | 'audit_log_col_last_login' /* Last login */
  | 'audit_log_login_type_okta' /* Okta */
  | 'audit_log_login_type_mimecast_local' /* Mimecast .local */
  | 'audit_log_lookup_error' /* Unable to load login history. Please try again. */
  | 'audit_log_no_results' /* No recent tenants for this employee. */;

class Text extends c42Text<TextKey> {}

const options = { warnOnMissingKeys: process.env.NODE_ENV === 'development' };
export default new Text(options);
